import React from "react";
import Sortable from "react-anything-sortable";
import SortItem from "../../components/SortableItem";
import { ProgressBar } from "../../components/LoadingComp";
import axios from "axios";
import constant from "../../constant";
import "./style.scss";

export default class Step1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: 0,
      previewImages: null,
      errors: [],
      imgPath: `${constant.phpHost}limage/temp/`
    };
  }

  componentDidMount() {
    let _this = this;
    let { spaceId, listing } = this.props;

    if (listing === "edit") {
      axios
        .get(`${constant.phpHost}action/listing.php`, {
          params: {
            todo: "get_listing_images",
            space_id: spaceId
          }
        })
        .then(res => {
          localStorage.setItem(spaceId + "_images", JSON.stringify(res.data));

          this.setState(
            {
              imgPath: `${constant.phpHost}limage/`
            },
            _this.handleRefreshImage()
          );
        });
    } else {
      this.handleRefreshImage();
    }
  }

  handleRefreshImage = () => {
    let get_images = JSON.parse(
      localStorage.getItem(this.props.spaceId + "_images")
    );

    if (get_images) {
      this.setState({
        previewImages: get_images
      });
    }
  };

  handleClick = () => {
    this.refs.fileUploader.click();
  };

  handleImageChange = e => {
    e.preventDefault();
    let _this = this;
    let { spaceId, isLogin, listing } = this.props;
    let get_images = JSON.parse(localStorage.getItem(spaceId + "_images"));

    let formData = new FormData();
    formData.append("todo", "insert_images");
    formData.append("space_id", spaceId);
    formData.append("listing", listing);
    formData.append("is_login", isLogin);

    let { files } = e.target;
    for (let i = 0; i < files.length; i++) {
      formData.append("files[" + i + "]", files[i]);
    }

    axios
      .post(`${constant.phpHost}action/listing.php`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        onUploadProgress: progress => {
          _this.setState({
            progress: Math.round((progress.loaded * 100) / progress.total)
          });
        }
      })
      .then(res => {
        let images = res.data;
        if (get_images) images = get_images.concat(images);
        localStorage.setItem(spaceId + "_images", JSON.stringify(images));

        _this.setState({
          previewImages: images,
          errors: {},
          progress: 0
        });
      });
  };

  // Sorting/Dragging Image
  handleSort = sortData => {
    let { spaceId } = this.props;
    let get_images = JSON.parse(localStorage.getItem(spaceId + "_images"));

    let array = [];
    sortData.map((sort, i) => (array[i] = get_images[sort]));
    localStorage.setItem(spaceId + "_images", JSON.stringify(array));

    this.handleRefreshImage();
  };

  // Delete Image
  delete_image_listing = (img, id) => {
    let { spaceId, isLogin, listing } = this.props;
    let get_images = JSON.parse(localStorage.getItem(spaceId + "_images"));

    if (get_images && get_images.length > 1) {
      get_images.splice(id, 1);
      localStorage.setItem(spaceId + "_images", JSON.stringify(get_images));

      let formData = new FormData();
      formData.append("todo", "unlink_images");
      formData.append("space_id", spaceId);
      formData.append("filename", img);
      formData.append("is_login", isLogin);
      formData.append("listing", listing);

      axios
        .post(`${constant.phpHost}action/listing.php`, formData)
        .then(res => {});
    } else {
      let { errors } = this.state;
      errors["delete"] = "Atleast one image should be mandatory.";
      this.setState({
        errors
      });
    }
    this.handleRefreshImage();
  };

  // Next Steps
  buttonStep = () => {
    if (this.img_validation()) {
      this.props.stepButton(2);
    }
  };

  img_validation = () => {
    let { previewImages, errors } = this.state;
    let formIsValid = true;

    if (!previewImages) {
      formIsValid = false;
      errors["images"] = "Upload atleast 1 image";
    }
    this.setState({ errors });
    return formIsValid;
  };

  render() {
    let { previewImages, errors, progress } = this.state;
    let { spaceId } = this.props;

    function chk_errors(field) {
      return errors && errors[field] ? (
        <span style={{ color: "red", paddingLeft: "50px" }}>
          {errors[field]}
        </span>
      ) : null;
    }

    function renderSortItem(imgs, i) {
      return (
        <SortItem key={i} sortData={i} className="sortItem">
          <img
            src={`${this.state.imgPath}${spaceId}/${imgs}|700x550`}
            draggable={false}
            alt=""
          />
          <span>{i + 1}</span>
          <div className="action">
            <i
              className="fa fa-trash"
              onClick={() => this.delete_image_listing(imgs, i)}
            />
          </div>
        </SortItem>
      );
    }

    return (
      <div>
        <h3 className="heading"> Upload Photos </h3>

        <div
          className={`image_block ${previewImages ? "image_height" : ""}`}
          onClick={this.handleClick}
        >
          <input
            ref="fileUploader"
            type="file"
            name="picture"
            onChange={this.handleImageChange}
            accept=".gif,.jpg,.jpeg,.png"
            multiple
          />
          <img
            src="\assets\images\upld_pic.jpg"
            onClick={this.handleClick}
            alt="pic"
          />
          <div>
            <p className="color_red_b">Upload Photos</p>
            <p>+Add atleast 1 Photo</p>
          </div>
        </div>

        {progress > 0 ? (
          <ProgressBar
            progress={progress}
            customStyle={{ margin: "30px 50px" }}
          />
        ) : null}

        <Sortable className="sortable" dynamic onSort={this.handleSort}>
          {previewImages && previewImages.map(renderSortItem, this)}
        </Sortable>

        {chk_errors("delete") || chk_errors("images")}

        <div className="button">
          <div className="prev_button"></div>
          <div className="next_button">
            <button onClick={this.buttonStep}>
              {window.innerWidth < 767 ? "NEXT" : "NEXT STEP"}
              <span>&#x276F;</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}
